const doc = [({"en":({"adminConstantPayType":({"all":"Available for all", "onSite":"on-site", "prePayment":"pre-payment"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;